const _ = require('lodash');
const defaultState = {
    instructions: [],
    loading: false,
    errors:{},
    units: []
}
  
export default (state=defaultState, action={}) => {
    switch (action.type) {
        case 'FETCH_INSTRUCTIONS_FULFILLED': {
            return {
                ...state,
                instructions: action.payload.data,
                loading: false,
                errors: {}
            }
        }

        case 'FETCH_INSTRUCTIONS_PENDING': {
            return {
                ...state,
                loading: true,
                errors: {}
            }
        }

        case 'FETCH_INSTRUCTIONS_REJECTED': {
            return {
                ...state,
                loading: false,
                errors: { global: action.payload.message }
            }
        }

        /*case 'REFRESH_INSTRUCTIONS_FULFILLED': {
            return {
                ...state,
                instructions: action.payload.data,
                loading: false,
                errors: {}
            }
        }*/

        case 'FETCH_ID_UNITS_FULFILLED': {
        
            let arrayMain=[];
            let newItem = {};
            
            if(Array.isArray(action.payload.data)){
                action.payload.data.forEach((element,index) => {
                    newItem={};//limpa para criar um novo
                    newItem["key"] = index;
                    newItem["text"] = element.COD_UF;
                    newItem["value"] = element.ID;

                    arrayMain.push(newItem);
                });
            }else{
                console.log('FETCH_ID_UNITS_FULFILLED error: ');
                console.dir(action.payload.data);
            }
            
            return {
                ...state,
                units: arrayMain
            }
        }      

        case 'ADD_INSTRUCTIONS_FULFILLED': {

            let mergedInstructions = [...state.instructions, ...action.newInstructions];
            let orderedInstructions = _.orderBy(
                    mergedInstructions, 
                    ['ORDER_PHO', 'CP_DESC' ,'BEGIN_DATE','BEGIN_TIME'], 
                    ['asc', 'asc', 'desc', 'desc']
                );

            return {
                ...state,
                instructions: orderedInstructions
            }
        }

        case 'VALIDATE_INSTRUCTION_FULFILLED': {
            
            const id = action.instructionId;
            const idGu = action.instructionIdGu;
            const newItem = action.newItem;
            let finalList = [];
            const comments = action.comments;

            //validar se instrução validada é ou não para substituir a que já está (caso seja retroativa)
            if(newItem.ID === id){
                // Step 1. Remove previous validated for the same generation unit
                // Step 2. Change the staus of the new one to "validated"
                state.instructions.forEach(element => {
                    if (element.ID === id ) {
                        finalList.push({...element, STATUS: 'EXECUTADA', COMMENTS_EDPP: comments});
                    }
                    else if ( !((element.ID_GU === idGu) && (element.STATUS === 'EXECUTADA'))) {
                        finalList.push(element);
                    }
                });
            }else{//devolve lista sem o item validado, porque n era o mais recente
                state.instructions.forEach(element => {
                    if (element.ID !== id ) {
                        finalList.push(element);
                    }           
                });
            }
            return {
                ...state,
                instructions: finalList
            }
        }

        case 'SEE_INSTRUCTION_FULFILLED': {
            
            const id = action.instructionId;
            const comments = action.comments;
            let status = 'ACEITE';

            return {
                ...state,
                instructions: state.instructions.map(item => item.ID === id ? {...item, STATUS: status , COMMENTS_EDPP: comments} : item)
            }
        }

        case 'REJECT_INSTRUCTION_FULFILLED': {
            
            const id = action.instructionId;
            const comments = action.comments;
            let status = 'RECLAMADA';

            return {
                ...state,
                instructions: state.instructions.map(item => item.ID === id ? {...item, STATUS: status , COMMENTS_EDPP: comments} : item)
            }
        }      
        
        case 'CANCEL_INSTRUCTION_FULFILLED': {
            const id = action.instructionId;
            return {
                ...state,
                instructions: state.instructions.filter(item => item.ID !== id)
            }
        }

        case 'BAN_INSTRUCTION_FULFILLED': { 

            const id = action.instructionId;
            const comments = action.comments;
            const status = 'ACEITE';

            return {
                ...state,
                instructions: state.instructions.map(item => item.ID === id ? {...item, STATUS: status , COMMENTS_EDPP: comments} : item)
            }
        }

        case 'EDIT_INSTRUCTION_FULFILLED': {

            const id = action.instruction.ID;
            const newItem = action.instruction;
            let finalList = [];

            // Step 1. Remove previous previous version of ID
            // Step 2. Add new version
            state.instructions.forEach(element => {

                if (element.ID === id ) {
                    finalList.push(newItem);
                }
                else {
                    finalList.push(element);
                }
                
            });

            return {
                ...state,
                instructions: finalList
            }
        }
        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/instruction-hidro-reducer.js